(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('fo-intro-on')) return;

  var el = document.getElementById('fo-intro');
  if (!el) return;

  var video = el.querySelector('[data-fo-intro-video]');
  var stage = el.querySelector('[data-fo-intro-stage]');
  var bar = el.querySelector('[data-fo-intro-bar]');
  var skipBtn = el.querySelector('[data-fo-intro-skip]');
  var bandT = el.querySelector('[data-fo-band-t]');
  var bandB = el.querySelector('[data-fo-band-b]');
  var seamLayers = !!(bandT || el.querySelector('.fo-intro__edge-y'));

  function num(attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isFinite(v) ? v : fallback;
  }

  var fadeMs = num('data-fo-fade', 1000);
  var skipFadeMs = num('data-fo-skip-fade', 520);
  var freezeMs = num('data-fo-freeze', 0);
  var maxWait = num('data-fo-max-wait', 3000);
  var clickToSkip = el.getAttribute('data-fo-click-skip') === '1';
  var forced = el.getAttribute('data-fo-force') === '1';

  var morphMs = num('data-fo-morph-ms', 1100);
  var morphLead = num('data-fo-morph-lead', 300);
  var morphHold = num('data-fo-morph-hold', 140);
  var morphEase = el.getAttribute('data-fo-morph-ease') || 'cubic-bezier(0.16, 1, 0.3, 1)';
  var matchW = num('data-fo-match-w', 100) / 100;
  var matchX = num('data-fo-match-x', 0) / 100;
  var matchY = num('data-fo-match-y', 8) / 100;
  var focalY = num('data-fo-focal-y', 50) / 100;
  var heroSel = (el.getAttribute('data-fo-hero-sel') || '').trim();

  var fitMode = el.getAttribute('data-fo-fit') || 'cover';
  var safeT = num('data-fo-safe-t', 3.5) / 100;
  var safeB = num('data-fo-safe-b', 7.5) / 100;
  var safeL = num('data-fo-safe-l', 20) / 100;
  var safeR = num('data-fo-safe-r', 31) / 100;

  var bandPct = num('data-fo-band', 12) / 100;
  var bandAuto = el.getAttribute('data-fo-band-auto') === '1';

  /* con ?intro=1 l'intro è voluta esplicitamente, quindi vale anche la morph */
  var reduced = !forced && !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var morphEnabled = el.getAttribute('data-fo-morph') === '1' && !!stage && !reduced;

  var finished = false;
  var started = false;
  var waiting = false;
  var morphing = false;
  var rafId = null;
  var watchdog = null;
  var graceTimer = null;
  var morphTimer = null;
  var sampleTimer = null;

  function blockEvent(e) {
    if (finished) return;
    if (e.cancelable) e.preventDefault();
  }

  function blockKeys(e) {
    if (finished) return;
    if (e.key === 'Escape') {
      finish(true);
      return;
    }
    if (
      e.key === 'ArrowDown' ||
      e.key === 'ArrowUp' ||
      e.key === 'PageDown' ||
      e.key === 'PageUp' ||
      e.key === 'Home' ||
      e.key === 'End' ||
      e.key === ' '
    ) {
      if (e.cancelable) e.preventDefault();
    }
  }

  window.addEventListener('wheel', blockEvent, { passive: false });
  window.addEventListener('touchmove', blockEvent, { passive: false });
  window.addEventListener('keydown', blockKeys, false);

  function releaseListeners() {
    window.removeEventListener('wheel', blockEvent, { passive: false });
    window.removeEventListener('touchmove', blockEvent, { passive: false });
    window.removeEventListener('keydown', blockKeys, false);
    window.removeEventListener('resize', onResize, false);
    document.removeEventListener('pointerdown', onUserGesture, true);
    document.removeEventListener('keydown', onUserGesture, true);
  }

  function tick() {
    if (finished || !video) return;
    var d = video.duration;
    if (bar && d && isFinite(d) && d > 0) {
      var p = Math.min(1, video.currentTime / d);
      bar.style.transform = 'scaleX(' + p + ')';
    }
    rafId = window.requestAnimationFrame(tick);
  }

  /* ---------------------------------------------------------------------
     Match-cut geometrico (FLIP)

     L'ultimo fotogramma del video è il ritaglio 16:9 della foto hero, quindi
     il salto percepito è solo di scala e posizione. Si porta lo stage sulla
     geometria finale e gli si applica la trasformazione inversa: il fotogramma
     resta identico, poi si anima la trasformazione fino all'identità.
     --------------------------------------------------------------------- */

  function pctOf(token, fallback) {
    if (!token) return fallback;
    if (token === 'left' || token === 'top') return 0;
    if (token === 'right' || token === 'bottom') return 1;
    if (token === 'center') return 0.5;
    var v = parseFloat(token);
    if (!isFinite(v)) return fallback;
    return token.indexOf('%') > -1 ? v / 100 : fallback;
  }

  /* rettangolo realmente dipinto da immagine o video, tenendo conto di object-fit */
  function paintedRect(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth || img.videoWidth;
    var nh = img.naturalHeight || img.videoHeight;
    if (!r.width || !r.height) return null;
    if (!nw || !nh) return { x: r.left, y: r.top, w: r.width, h: r.height };

    var cs = window.getComputedStyle(img);
    var fit = cs.objectFit || 'fill';
    var ar = nw / nh;
    var w = r.width;
    var h = r.height;

    if (fit === 'contain' || fit === 'scale-down') {
      if (w / h > ar) w = h * ar;
      else h = w / ar;
    } else if (fit === 'cover') {
      if (w / h < ar) w = h * ar;
      else h = w / ar;
    } else if (fit === 'none') {
      w = nw;
      h = nh;
    }

    var pos = (cs.objectPosition || '50% 50%').split(/\s+/);
    var px = pctOf(pos[0], 0.5);
    var py = pctOf(pos[1], 0.5);

    return { x: r.left + (r.width - w) * px, y: r.top + (r.height - h) * py, w: w, h: h };
  }

  function findHero() {
    var sels = [];
    if (heroSel) sels.push(heroSel);
    sels.push('[data-fo-hero-target]', '.fo-immersive__model--hero img', '[data-role="hero"] img');
    for (var i = 0; i < sels.length; i++) {
      var node = document.querySelector(sels[i]);
      if (!node) continue;
      if (node.tagName === 'IMG' && !(node.complete && node.naturalWidth > 0)) continue;
      return node;
    }
    return null;
  }

  function videoAspect() {
    if (video && video.videoWidth && video.videoHeight) return video.videoWidth / video.videoHeight;
    return 16 / 9;
  }

  /* dove il video è dipinto adesso: object-fit cover sull'intero viewport */
  function coverRect(ar) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var w = vw;
    var h = vw / ar;
    if (h < vh) {
      h = vh;
      w = vh * ar;
    }
    return { x: (vw - w) / 2, y: (vh - h) * focalY, w: w, h: h };
  }

  /* Inquadratura a schermo intero.

     `cover` puro ritaglia in alto e in basso appena il viewport è più largo di
     16:9 (una finestra 1920x900 mangia 90px sopra, ma sulla testa del soggetto
     ce ne sono solo 40): le teste venivano tagliate. Qui si riempie lo schermo
     il più possibile con il vincolo che il ritaglio non superi mai i margini
     vuoti misurati sul fotogramma, e lo si ripartisce fra i lati opposti in
     proporzione a quei margini invece di centrarlo. Quando il viewport è troppo
     estremo il video si rimpicciolisce quel tanto che basta, lasciando bande
     del colore di sfondo. */
  function fitRect(ar) {
    /* si misura il riquadro dell'overlay, non il viewport: su mobile le barre
       del browser rendono 100vh e innerHeight discordanti */
    var vr = el.getBoundingClientRect();
    var vw = vr.width || window.innerWidth;
    var vh = vr.height || window.innerHeight;
    var sy = Math.max(0, Math.min(0.8, safeT + safeB));
    var sx = Math.max(0, Math.min(0.8, safeL + safeR));

    var h = Math.max(vh, vw / ar);
    h = Math.min(h, vh / (1 - sy), vw / (1 - sx) / ar);
    h = Math.max(h, Math.min(vh, vw / ar));
    var w = h * ar;

    var ovX = w - vw;
    var ovY = h - vh;

    return {
      x: ovX > 0 ? -ovX * (sx > 0 ? safeL / sx : 0.5) : (vw - w) / 2,
      y: ovY > 0 ? -ovY * (sy > 0 ? safeT / sy : 0.5) : (vh - h) / 2,
      w: w,
      h: h
    };
  }

  /* ---------------------------------------------------------------------
     Bande sopra/sotto

     I margini vuoti del fotogramma sono 3,7% in alto e 2,9% in basso (misurati
     riga per riga su più istanti del video): dentro il video non c'è spazio per
     una sfumatura credibile senza sbiadire teste e piedi. Quindi la transizione
     sta fuori dal fotogramma, sulla banda, che parte dal colore del bordo del
     fotogramma e si spegne verso l'esterno.

     Il bordo non è una tinta piatta: da sinistra a destra cambia di ~24 punti,
     quindi si campionano SAMPLES colonne e la banda diventa una rampa
     orizzontale con la stessa dissolvenza verticale applicata come maschera.
     --------------------------------------------------------------------- */

  var SAMPLES = 16;
  var sampleCtx = null;
  var canSample = bandAuto;
  var bandCols = { t: null, b: null };

  function readStrip(sx, sw, sy, sh) {
    sampleCtx.drawImage(video, sx, sy, sw, sh, 0, 0, SAMPLES, 1);
    var d = sampleCtx.getImageData(0, 0, SAMPLES, 1).data;
    var out = [];
    for (var i = 0; i < SAMPLES; i++) out.push([d[i * 4], d[i * 4 + 1], d[i * 4 + 2]]);
    return out;
  }

  /* i salti di colore fra un campione e l'altro si vedrebbero come uno sfarfallio
     della banda: ci si avvicina per gradi */
  function easeCols(key, next) {
    var cur = bandCols[key];
    if (!cur) {
      bandCols[key] = next;
      return next;
    }
    for (var i = 0; i < next.length; i++) {
      for (var c = 0; c < 3; c++) cur[i][c] += (next[i][c] - cur[i][c]) * 0.3;
    }
    return cur;
  }

  /* le fermate cadono al centro della colonna campionata: fuori dalle fermate
     estreme il gradiente resta piatto, che è esattamente il comportamento voluto */
  function setBandImage(key, cols) {
    var stops = [];
    for (var i = 0; i < cols.length; i++) {
      stops.push(
        'rgb(' +
          Math.round(cols[i][0]) +
          ',' +
          Math.round(cols[i][1]) +
          ',' +
          Math.round(cols[i][2]) +
          ') ' +
          (((i + 0.5) / cols.length) * 100).toFixed(2) +
          '%'
      );
    }
    el.style.setProperty('--fo-band-img-' + key, 'linear-gradient(to right, ' + stops.join(', ') + ')');
  }

  /* la rampa copre tutta la larghezza del fotogramma: così vale sia per il
     livello dentro al video sia per la banda, che viene allineata al video
     con background-size e background-position invece di essere riscalata */
  function sampleEdges() {
    if (!canSample || finished || video.readyState < 2) return;
    var vw = video.videoWidth;
    var vh = video.videoHeight;
    if (!vw || !vh) return;
    try {
      if (!sampleCtx) {
        var c = document.createElement('canvas');
        c.width = SAMPLES;
        c.height = 1;
        sampleCtx = c.getContext('2d', { willReadFrequently: true });
        if (!sampleCtx) {
          canSample = false;
          return;
        }
      }
      var strip = Math.max(2, Math.round(vh * 0.012));
      setBandImage('t', easeCols('t', readStrip(0, vw, 0, strip)));
      setBandImage('b', easeCols('b', readStrip(0, vw, vh - strip, strip)));
    } catch (e) {
      /* sorgente cross-origin: il canvas è contaminato, restano i colori del tema */
      canSample = false;
    }
  }

  function updateBands() {
    if (!seamLayers || finished || morphing) return;
    var vr = el.getBoundingClientRect();
    var p = paintedRect(video);
    if (!p || !p.w || !p.h || !vr.height) {
      el.classList.remove('is-banded-y');
      return;
    }

    var top = p.y - vr.top;
    var gapT = top;
    var gapB = vr.height - (top + p.h);
    var on = gapT > 1 || gapB > 1;
    el.classList.toggle('is-banded-y', on);
    if (!on) return;

    sampleEdges();
    if (!bandT || !bandB || bandPct <= 0) return;

    /* la banda segue la larghezza dipinta: se ci sono anche bande laterali non
       deve sbordare sul crema dove sopra il video non c'è nulla */
    var left = Math.max(0, p.x - vr.left);
    var width = Math.min(vr.width - left, p.w);
    var maxH = vr.height * bandPct;
    /* la rampa orizzontale è tarata sul fotogramma intero: la banda ne mostra
       solo la porzione che sta davvero sopra il video */
    var bgSize = p.w + 'px 100%';
    var bgPos = p.x - vr.left - left + 'px 0';

    var ht = Math.max(0, Math.min(maxH, gapT + 1));
    bandT.style.left = left + 'px';
    bandT.style.width = width + 'px';
    bandT.style.top = top + 1 - ht + 'px';
    bandT.style.height = ht + 'px';
    bandT.style.backgroundSize = bgSize;
    bandT.style.backgroundPosition = bgPos;

    var hb = Math.max(0, Math.min(maxH, gapB + 1));
    bandB.style.left = left + 'px';
    bandB.style.width = width + 'px';
    bandB.style.top = top + p.h - 1 + 'px';
    bandB.style.height = hb + 'px';
    bandB.style.backgroundSize = bgSize;
    bandB.style.backgroundPosition = bgPos;
  }

  function applyFit() {
    if (morphing || finished) return;
    if (fitMode === 'auto' && stage) {
      var r = fitRect(videoAspect());
      stage.style.transition = 'none';
      applyStageRect(r);
      stage.style.transform = 'translate3d(0,0,0) scale(1)';
      /* con le bande il bordo del video stacca sul crema: si sfuma solo allora */
      el.classList.toggle('is-banded-x', r.x > 0.5);
    }
    el.classList.add('is-fitted');
    updateBands();
  }

  /* dove deve finire: stesso ritaglio, stessa scala e stessa posizione della foto hero */
  function targetRect(ar) {
    var hero = findHero();
    if (!hero) return null;
    var hr = hero.tagName === 'IMG' ? paintedRect(hero) : null;
    if (!hr) {
      var b = hero.getBoundingClientRect();
      if (!b.width || !b.height) return null;
      hr = { x: b.left, y: b.top, w: b.width, h: b.height };
    }
    var w = hr.w * matchW;
    var h = w / ar;
    return { x: hr.x + hr.w * matchX, y: hr.y + hr.h * matchY, w: w, h: h };
  }

  function applyStageRect(t) {
    stage.style.inset = 'auto';
    stage.style.left = t.x + 'px';
    stage.style.top = t.y + 'px';
    stage.style.width = t.w + 'px';
    stage.style.height = t.h + 'px';
  }

  function startMorph() {
    if (morphing || finished) return;
    morphing = true;
    if (sampleTimer) window.clearInterval(sampleTimer);

    var ar = videoAspect();
    var t = morphEnabled ? targetRect(ar) : null;

    /* niente hero misurabile: si torna alla sola dissolvenza, senza salti */
    if (!t) {
      morphEnabled = false;
      finish(false);
      return;
    }

    /* punto di partenza: il rettangolo davvero dipinto ora, qualunque sia
       l'adattamento in corso, così la trasformazione inversa è esatta */
    var s = paintedRect(video) || coverRect(ar);

    el.classList.add('is-morphing');
    root.classList.add('fo-intro-morphing');

    stage.style.transition = 'none';
    applyStageRect(t);

    var scale = s.w / t.w;
    var dx = s.x + s.w / 2 - (t.x + t.w / 2);
    var dy = s.y + s.h / 2 - (t.y + t.h / 2);
    stage.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + scale + ')';

    /* reflow: senza questo il browser fonde i due stati e la morph non parte */
    void stage.offsetHeight;

    stage.style.transition = 'transform ' + morphMs + 'ms ' + morphEase;
    stage.style.transform = 'translate3d(0,0,0) scale(1)';

    document.dispatchEvent(
      new CustomEvent('fo:intro:morph', { detail: { duration: morphMs, rect: t } })
    );

    morphTimer = window.setTimeout(function () {
      finish(false);
    }, morphMs + morphHold);
  }

  /* la geometria dell'hero cambia con il viewport: si ricalcola al volo,
     e se capita a morph in corso si chiude sul rettangolo aggiornato */
  function onResize() {
    if (finished || !stage) return;
    if (!morphing) {
      applyFit();
      return;
    }
    var t = targetRect(videoAspect());
    if (!t) return;
    stage.style.transition = 'none';
    applyStageRect(t);
    stage.style.transform = 'translate3d(0,0,0) scale(1)';
  }

  window.addEventListener('resize', onResize, false);

  /* Congela l'ultimo fotogramma: niente loop, niente rewind, niente frame nero. */
  function freezeFrame() {
    if (!video) return;
    try {
      video.pause();
    } catch (e) {}
  }

  function endNaturally() {
    if (finished) return;
    freezeFrame();
    if (morphEnabled && !morphing) {
      startMorph();
      return;
    }
    if (morphing) return;
    finish(false);
  }

  function finish(isSkip) {
    if (finished) return;
    finished = true;

    if (rafId) window.cancelAnimationFrame(rafId);
    if (watchdog) window.clearTimeout(watchdog);
    if (graceTimer) window.clearTimeout(graceTimer);
    if (morphTimer) window.clearTimeout(morphTimer);
    if (sampleTimer) window.clearInterval(sampleTimer);

    /* si marca "vista" solo se è partita davvero: un fallback non deve
       bruciare l'intro per tutta la sessione */
    if (started && !forced) {
      try {
        sessionStorage.setItem('fo_intro_seen', String(Date.now()));
      } catch (e) {}
    }

    el.classList.add('is-ending');
    if (isSkip) el.classList.add('is-skip');

    /* forza un reflow così la transizione parte anche se le classi cambiano nello stesso frame */
    void el.offsetHeight;

    root.classList.add('fo-intro-reveal');
    el.classList.add('is-out');

    var wait = isSkip ? skipFadeMs : fadeMs;

    window.setTimeout(function () {
      root.classList.remove('fo-intro-on', 'fo-intro-reveal', 'fo-intro-morphing');
      releaseListeners();
      try {
        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch (e) {}
      if (el.parentNode) el.parentNode.removeChild(el);
      document.dispatchEvent(new CustomEvent('fo:intro:done'));
    }, wait + 60);

    /* l'hero è già visibile sotto: avvisiamo subito chi deve reagire alla dissolvenza */
    document.dispatchEvent(new CustomEvent('fo:intro:ending', { detail: { skipped: !!isSkip, duration: wait } }));
  }

  function onPlaying() {
    if (started || finished) return;
    started = true;
    waiting = false;
    if (watchdog) window.clearTimeout(watchdog);
    if (graceTimer) window.clearTimeout(graceTimer);
    el.classList.remove('is-waiting');

    var d = video.duration;
    if (d && isFinite(d) && d > 0) {
      /* l'overlay brand deve essere già svanito quando parte il match-cut */
      var lead = morphEnabled ? morphLead : 0;
      el.style.setProperty('--fo-intro-brand-dur', Math.max(2000, d * 1000 - freezeMs - lead - 400) + 'ms');
    }

    el.classList.add('is-playing');

    if (seamLayers) {
      updateBands();
      sampleTimer = window.setInterval(function () {
        if (!document.hidden) updateBands();
      }, 500);
    }

    tick();
  }

  function onTimeUpdate() {
    if (finished || !video) return;
    var d = video.duration;
    if (!d || !isFinite(d)) return;
    var left = d - video.currentTime;

    if (morphEnabled && !morphing && left <= (freezeMs + morphLead) / 1000 + 0.03) startMorph();
    if (left <= freezeMs / 1000 + 0.05) {
      if (morphEnabled) freezeFrame();
      else endNaturally();
    }
  }

  if (!video) {
    finish(false);
    return;
  }

  video.addEventListener('loadedmetadata', applyFit);
  video.addEventListener('playing', onPlaying);
  video.addEventListener('timeupdate', onTimeUpdate);
  applyFit();
  video.addEventListener('ended', endNaturally);
  video.addEventListener('error', function () {
    finish(false);
  });

  function tryPlay() {
    if (finished || started) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(enterWaiting);
  }

  function onUserGesture() {
    if (!waiting || finished) return;
    tryPlay();
  }

  /* autoplay bloccato o buffering lento: si mostra il poster e si parte al primo tocco,
     invece di lasciare uno schermo vuoto o sparire senza motivo */
  function enterWaiting() {
    if (finished || started || waiting) return;
    waiting = true;
    el.classList.add('is-waiting');

    document.addEventListener('pointerdown', onUserGesture, true);
    document.addEventListener('keydown', onUserGesture, true);

    graceTimer = window.setTimeout(function () {
      if (!started) finish(false);
    }, forced ? 15000 : 8000);
  }

  watchdog = window.setTimeout(enterWaiting, maxWait);

  tryPlay();

  if (skipBtn) {
    skipBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (waiting && !started) {
        finish(false);
        return;
      }
      finish(true);
    });
  }

  if (clickToSkip) {
    el.addEventListener('click', function () {
      if (waiting && !started) return;
      finish(true);
    });
  }

  /* uscendo dalla tab l'intro perde senso: si chiude alla riapertura */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && !finished && video) {
      try {
        video.pause();
      } catch (e) {}
    } else if (!document.hidden && !finished && video && started && !morphing) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  });
})();
